/* ============================================
   Kaffeesack — Produktseite v5.0
   Minimal · Sicher · Nichts kaputt machen
   ============================================ */

(function () {
  'use strict';

  function qs(sel) {
    try { return document.querySelector(sel); } catch(e) { return null; }
  }
  function qsa(sel) {
    try { return Array.from(document.querySelectorAll(sel)); } catch(e) { return []; }
  }

  /* ─── 1. MwSt-Hinweis ─── */
  function initTaxNote() {
    try {
      var priceEl = qs('.product__price');
      if (!priceEl || qs('.ks-tax-note')) return;
      var note = document.createElement('div');
      note.className = 'ks-tax-note';
      note.innerHTML = 'inkl. MwSt. · zzgl. <a href="/policies/shipping-policy">Versandkosten</a>';
      priceEl.parentNode.insertBefore(note, priceEl.nextSibling);
    } catch(e) {}
  }

  /* ─── 2. Trust-Zone ─── */
  function initTrustZone() {
    try {
      if (qs('.ks-trust-zone')) return;
      var anchor = qs('.shopify-payment-button__more-options')
        || qs('[data-payment-button]')
        || qs('.product__form-buttons');
      if (!anchor) return;

      var zone = document.createElement('div');
      zone.className = 'ks-trust-zone';
      zone.innerHTML =
        '<div class="ks-trust-zone__grid">' +
          '<div class="ks-trust-zone__item"><span class="ks-trust-zone__icon">🚚</span>Gratis Versand ab 80€</div>' +
          '<div class="ks-trust-zone__item"><span class="ks-trust-zone__icon">📦</span>Lieferung: 1–3 Werktage</div>' +
          '<div class="ks-trust-zone__item"><span class="ks-trust-zone__icon">☕</span>Frisch geröstet</div>' +
          '<div class="ks-trust-zone__item"><span class="ks-trust-zone__icon">↩️</span>14 Tage Rückgabe</div>' +
        '</div>';

      var target = anchor.closest('.product__form-block') || anchor.parentNode;
      if (target && target.parentNode) {
        target.parentNode.insertBefore(zone, target.nextSibling);
      }
    } catch(e) {}
  }

  /* ─── 3. Akkordeon ─── */
  function initAccordion() {
    try {
      var descBlock = qs('.product__description');
      if (!descBlock || qs('.ks-accordion')) return;

      var descHTML = descBlock.innerHTML;

      var oldBtn = qs('.ks-read-more');
      if (oldBtn) oldBtn.remove();
      descBlock.classList.remove('is-collapsed');

      var brewBlock = null;
      qsa('.product__block').forEach(function (b) {
        try {
          var t = b.textContent.toLowerCase();
          if (t.indexOf('zubereitung') !== -1 && b !== descBlock.closest('.product__block')) {
            brewBlock = b;
          }
        } catch(e) {}
      });

      var brewHTML = '<div class="ks-brew-methods">' +
        '<div class="ks-brew-card"><div class="ks-brew-card__icon">☕</div><div class="ks-brew-card__label">Siebträger</div></div>' +
        '<div class="ks-brew-card"><div class="ks-brew-card__icon">⚙️</div><div class="ks-brew-card__label">Vollautomat</div></div>' +
        '<div class="ks-brew-card"><div class="ks-brew-card__icon">🫖</div><div class="ks-brew-card__label">French Press</div></div>' +
        '</div>';

      var tmp = document.createElement('div');
      tmp.innerHTML = descHTML;
      var txt = tmp.textContent;
      var dets = [];
      [[/Herkunft[:\s]+([^\n.]+)/i,'Herkunft'],[/Aufbereitung[:\s]+([^\n.]+)/i,'Aufbereitung'],
       [/Röstprofil[:\s]+([^\n.]+)/i,'Röstung'],[/Sensorik[:\s]+([^\n.]+)/i,'Sensorik']].forEach(function(p) {
        var m = txt.match(p[0]);
        if (m) dets.push('<dt>'+p[1]+'</dt><dd>'+m[1].trim()+'</dd>');
      });
      var detHTML = dets.length ? '<dl class="ks-details-grid">'+dets.join('')+'</dl>' : '<p>Siehe Beschreibung</p>';

      var acc = document.createElement('div');
      acc.className = 'ks-accordion';
      acc.innerHTML =
        sec('Beschreibung', descHTML) +
        sec('Zubereitungsempfehlung', brewHTML) +
        sec('Details & Herkunft', detHTML);

      var parentBlock = descBlock.closest('.product__block');
      if (parentBlock) {
        parentBlock.style.display = 'none';
        if (parentBlock.parentNode) {
          parentBlock.parentNode.insertBefore(acc, parentBlock.nextSibling);
        }
      } else {
        descBlock.style.display = 'none';
        if (descBlock.parentNode) {
          descBlock.parentNode.insertBefore(acc, descBlock.nextSibling);
        }
      }

      if (brewBlock) brewBlock.style.display = 'none';

      qsa('.ks-accordion__trigger').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var s = btn.closest('.ks-accordion__section');
          if (s) s.classList.toggle('is-open');
        });
      });
    } catch(e) {}
  }

  function sec(title, content) {
    return '<div class="ks-accordion__section">' +
      '<button class="ks-accordion__trigger" type="button">' + title +
      '<span class="ks-accordion__icon">▼</span></button>' +
      '<div class="ks-accordion__content">' + content + '</div></div>';
  }

  /* ─── 4. Social Share verstecken ─── */
  function killSocialShare() {
    try {
      // Klassen-basiert
      qsa('.social-sharing, .product__sharing, .product__share, .share-links, [class*="social-sharing"], [class*="share-buttons"], [class*="product__share"]').forEach(function (el) {
        var block = el.closest('.product__block');
        if (block) { block.classList.add('ks-hidden'); block.style.display = 'none'; }
        else el.style.display = 'none';
      });

      // Text + Link basiert: nur product__block scannen
      qsa('.product__block').forEach(function (block) {
        try {
          if (block.style.display === 'none') return;

          var links = block.querySelectorAll('a[href]');
          var socialCount = 0;
          for (var i = 0; i < links.length; i++) {
            var href = (links[i].href || '').toLowerCase();
            if (href.indexOf('twitter.com') !== -1 || href.indexOf('facebook.com/sharer') !== -1 || href.indexOf('pinterest.com/pin') !== -1) {
              socialCount++;
            }
          }
          if (socialCount >= 2) { block.classList.add('ks-hidden'); block.style.display = 'none'; return; }

          var text = block.textContent.trim();
          if (text.indexOf('Tweeten') !== -1 && text.indexOf('Teilen') !== -1) {
            block.classList.add('ks-hidden');
            block.style.display = 'none';
          }
        } catch(e) {}
      });
    } catch(e) {}
  }

  /* ─── 5. Sticky ATC (Mobile) ─── */
  function initStickyATC() {
    try {
      if (window.innerWidth > 768 || qs('.ks-sticky-atc')) return;

      var submitBtn = qs('[data-add-to-cart]');
      if (!submitBtn) return;

      var titleEl = qs('.product__title');
      var priceEl = qs('.product__price [data-product-price]') || qs('.product__price .money');

      var bar = document.createElement('div');
      bar.className = 'ks-sticky-atc';
      bar.innerHTML =
        '<div class="ks-sticky-atc__info">' +
          '<div class="ks-sticky-atc__title">' + (titleEl ? titleEl.textContent.trim() : '') + '</div>' +
          '<div class="ks-sticky-atc__price">' + (priceEl ? priceEl.textContent.trim() : '') + '</div>' +
        '</div>' +
        '<button class="ks-sticky-atc__btn" type="button">' +
          (submitBtn.disabled ? 'Ausverkauft' : 'In den Warenkorb') +
        '</button>';

      document.body.appendChild(bar);

      bar.querySelector('.ks-sticky-atc__btn').addEventListener('click', function () {
        if (!submitBtn.disabled) {
          submitBtn.click();
          this.textContent = '✓';
          var self = this;
          setTimeout(function () { self.textContent = 'In den Warenkorb'; }, 1500);
        }
      });

      if (priceEl) {
        try {
          new MutationObserver(function () {
            var p = bar.querySelector('.ks-sticky-atc__price');
            if (p && priceEl) p.textContent = priceEl.textContent.trim();
          }).observe(priceEl, { childList: true, subtree: true, characterData: true });
        } catch(e) {}
      }

      var showAfter = 400;
      var visible = false;
      window.addEventListener('scroll', function () {
        var shouldShow = window.scrollY > showAfter;
        if (shouldShow !== visible) {
          visible = shouldShow;
          bar.classList.toggle('is-visible', visible);
        }
      }, { passive: true });
    } catch(e) {}
  }

  /* ─── 6. Mobile Bilder — Flickity resize erzwingen ─── */
  /*
     CSS fixiert .flickity-viewport auf height:100vw !important
     damit Flickity die Höhe nicht per inline-Style verschieben kann.
     Hier rufen wir zusätzlich flkty.resize() auf, damit Flickity
     die Zell-Positionen für die neue 100vw Breite neu berechnet.
     Zweiter Aufruf nach 4s fängt den lazy→eager Image-Switch ab
     (Theme schaltet nach 3s alle lazy Bilder auf eager).
  */
  function fixMobileSlider() {
    try {
      if (window.innerWidth > 767) return;
      if (typeof Flickity === 'undefined') return;

      /* Hauptslider resize */
      var slider = qs('.product__images__slider');
      if (slider) {
        var flkty = Flickity.data(slider);
        if (flkty) flkty.resize();
      }

      /* Thumbnail-Slider resize (war evtl. hidden bei Init) */
      var thumbNav = qs('.product__images__slider-nav');
      if (thumbNav) {
        var thumbFlkty = Flickity.data(thumbNav);
        if (thumbFlkty) {
          thumbFlkty.resize();
          thumbFlkty.reposition();
        }
      }
    } catch(e) {}
  }

  /* ─── INIT ─── */
  function init() {
    try {
      initTaxNote();
      initTrustZone();
      initAccordion();
      killSocialShare();
      setTimeout(initStickyATC, 500);
      setTimeout(killSocialShare, 1500);
      /* Flickity resize: nach Init + nach lazy→eager Switch */
      setTimeout(fixMobileSlider, 1000);
      setTimeout(fixMobileSlider, 4000);
    } catch(e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    setTimeout(init, 150);
  }
})();
